export const DEFAULT_PAGE_SIZE = 50;
export const BLANK_SYMBOL = "--";
export const NEW_PLANNING_TOUR_KEY = "onboarding:planning:new";
export const TIME_FORMAT = "h:mm a";
export const MachineCalibrations = [
  "speed",
  "gear",
  "rpm",
  "nozzle",
  "pressure",
] as const;
